export default "__VITE_ASSET__CNPXejSr__"